import request from '@/axios';

// 删除策略
export const deleteStrategy = (data) => {
    return request({
        url: `/lebo-desk/tv/strategy/manage/delete`,
        method: 'post',
        data
    })
}

// 获取导航详情
export const detail = (params) => {
    return request({
        url: '/lebo-desk/tv/strategy/manage/detail',
        method: 'get',
        params
    })
}

// 获取策略列表
export const list = (params) => {
    return request({
        url: '/lebo-desk/tv/strategy/manage/list',
        method: 'get',
        params
    })
}

// 获取在线策略列表
export const onlineList = (params) => {
    return request({
        url: '/lebo-desk/tv/strategy/manage/online-list',
        method: 'get',
        params
    })
}

// 新增或修改导航
export const submit = (data) => {
    return request({
        url: '/lebo-desk/tv/strategy/manage/submit',
        method: 'post',
        data
    })
}

// 提交审核
export const submitAudit = (data) => {
    return request({
        url: `/lebo-desk/tv/strategy/manage/submit-audit`,
        method: 'post',
        data
    })
}

// 撤销审核
export const cancelAudit = (data) => {
    return request({
        url: `/lebo-desk/tv/strategy/manage/cancel-audit`,
        method: 'post',
        data
    })
}

// 渠道命中
export const channelHit = (data) => {
    return request({
        url: `/lebo-desk/tv/strategy/manage/channel-hit`,
        method: 'post',
        data
    })
}

